(() => {
  const titleMerchantFrame = (root) => {
    if (!(root instanceof Document || root instanceof DocumentFragment || root instanceof Element)) return;
    const frames = root instanceof Element && root.matches('iframe#merchantwidgetiframe')
      ? [root]
      : root.querySelectorAll('iframe#merchantwidgetiframe');
    for (const frame of frames) {
      if (!frame.hasAttribute('title') || frame.getAttribute('title')?.trim() === '') {
        frame.setAttribute('title', 'Google customer reviews');
      }
    }
  };

  titleMerchantFrame(document);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) titleMerchantFrame(node);
    }
  }).observe(document.documentElement, {childList: true, subtree: true});
})();
